<template>
  <div>
    <Sidebar />
    <Content />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Sidebar from '@/components/Sidebar.vue'; // @ is an alias to /src
import Content from '@/components/PasswordChange.vue'; // @ is an alias to /src

@Component({
  components: {
    Sidebar,
    Content,
  },
})
export default class PasswordChange extends Vue {}
</script>
